import React, { useState, useEffect } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ProfileOutlined,
  ContactsOutlined,
  SolutionOutlined,
  ContainerOutlined,
  ProjectOutlined,
  ApiOutlined,
  UserOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  TeamOutlined, 
} from "@ant-design/icons";
import { Layout, Menu, Button, theme, Grid } from "antd";
import MenuButton from "../dropdown/Menu";
import { useLocation, Link } from "react-router-dom";
import { parseJWT } from "../../utils/tokenDecode";
import cookie from "react-cookies";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const Layout1 = (props) => {
  const location = useLocation();
  const screens = useBreakpoint();
  const token = cookie.load("token");
  const user = parseJWT(token);

  // Collapse state
  const [collapsed, setCollapsed] = useState(false);

  // Force collapse on mobile initially
  useEffect(() => {
    if (screens.xs) setCollapsed(true);
  }, [screens.xs]);

  // token for color
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  // Menu items
  const items = [
    {
      id: "12",
      img: <DashboardOutlined />,
      route: "/dashboard",
      title: "Dashboard",
      accessRole: ["admin", "property_management"],
    },
    {
      id: "11",
      img: <UserOutlined />,
      route: "/admin",
      title: "Admin",
      accessRole: ["admin"],
    },
    {
      id: "sub1",
      img: <ProfileOutlined />,
      title: "Properties",
      accessRole: ["admin", "property_management"],
      children: [
        { id: "2", route: "/add-property", title: "Add Properties" },
        { id: "1", route: "/", title: "Properties" },
        { id: "7", route: "/crm-properties", title: "CRM Properties" },
        { id: "6", route: "/draft-property", title: "Draft Properties" },
        {
          id: "8",
          route: "/unpublished-properties",
          title: "Unpublished Properties",
        },
      ],
    },
    {
      id: "9",
      img: <ApiOutlined />,
      route: "/seo",
      title: "SEO",
      accessRole: ["admin", "property_management"],
    },
    {
      id: "10",
      img: <ProjectOutlined />,
      route: "/blogs",
      title: "Blogs",
      accessRole: ["admin", "property_management"],
    },
    {
      id: "5",
      img: <ContainerOutlined />,
      route: "/property-inquiry",
      title: "Property Inquiries",
      accessRole: ["admin", "property_management"],
    },
    {
      id: "3",
      img: <SolutionOutlined />,
      route: "/carrers",
      title: "Careers",
      accessRole: ["admin", "property_management"],
    },
    {
      id: "4",
      img: <ContactsOutlined />,
      route: "/contact",
      title: "Contact Us",
      accessRole: ["admin", "property_management"],
    },
    {
      id: "13",
      img: <TeamOutlined />,
      route: "/our-team",
      title: "Our Team",
      accessRole: ["admin", "property_management"],
    },
    {
      id: "14",
      img: <DatabaseOutlined />,
      route: "/event-contacts",
      title: "Event Contacts",
      accessRole: ["admin", "property_management", "event_operator"],
    },
  ];

  const getItem = (label, key, icon, children) => ({
    key,
    icon,
    children,
    label,
  });

  const childTabs = (tab) =>
    getItem(
      <Link>{tab?.title}</Link>,
      tab?.id,
      tab.img,
      tab?.children?.map((child) =>
        getItem(<Link to={child?.route}>{child?.title}</Link>, child?.id)
      )
    );

  const userTabsPermissions = () => {
    return items.map((tab) => {
      if (tab.accessRole?.includes(user?.role)) {
        return tab?.children?.length > 0
          ? childTabs(tab)
          : getItem(<Link to={tab?.route}>{tab?.title}</Link>, tab.id, tab.img);
      }
      return null;
    });
  };

  const activeTabHandler = (route) => {
    switch (route) {
      case "/":
        return "1";
      case "/draft-property":
        return "6";
      case `/edit-property/${location?.pathname?.split("/")[2]}`:
        return "1";
      case "/add-property":
        return "2";
      case `/add-crm-properties`:
        return "2";
      case "/carrers":
        return "3";
      case "/contact":
        return "4";
      case "/property-inquiry":
        return "5";
      case "/crm-properties":
        return "7";
      case "/unpublished-properties":
        return "8";
      case "/seo":
        return "9";
      case `/edit-seo/${location?.pathname?.split("/")[2]}`:
        return "9";
      case "/blogs":
        return "10";
      case "/add-blog":
        return "10";
      case `/edit-blog/${location?.pathname?.split("/")[2]}`:
        return "10";
      case "/admin":
        return "11";
      case "/add-admin":
        return "11";
      case `/edit-admin/${location?.pathname?.split("/")[2]}`:
        return "11";
      case `/dashboard`:
        return "12";
      case `/our-team`:
        return "13";
      case "/add-team":
        return "13";
      case `/edit-team/${location?.pathname?.split("/")[2]}`:
        return "13";
      case "/event-contacts":
        return "14";
      default:
        return "1";
    }
  };

  const activeSubOptionHandler = (route) => {
    switch (route) {
      case "/":
      case "/add-property":
      case "/add-crm-properties":
      case "/draft-property":
      case "/crm-properties":
      case "/unpublished-properties":
      case `/edit-property/${location?.pathname?.split("/")[2]}`:
        return "sub1";
      default:
        return "";
    }
  };

  return (
    <Layout style={{ height: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={200}
        collapsedWidth={80}
      >
        <div className="sidebar_logo">
          {collapsed ? (
            user?.role === "event_operator" ? (
              <h6>EMI</h6>
            ) : (
              <Link to="/">
                <h6>EMI</h6>
              </Link>
            )
          ) : user?.role === "event_operator" ? (
            <h6>Empire Infratech</h6>
          ) : (
            <Link to="/">
              <h6>Empire Infratech</h6>
            </Link>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[activeTabHandler(location?.pathname)]}
          defaultOpenKeys={[activeSubOptionHandler(location?.pathname)]}
          items={userTabsPermissions()}
          selectedKeys={[activeTabHandler(location?.pathname)]}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: "20px", width: 64, height: 64 }}
          />
          <MenuButton />
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            overflowY: "scroll",
            background: colorBgContainer,
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Layout1;
